import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useFormContext, Controller } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import Maps from '../../Maps/Maps';
import { memo, useEffect, useRef, useState } from 'react';
import {
  Divider,
  Fab,
  FormControlLabel,
  Icon,
  InputAdornment,
  Tooltip,
  Typography,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { constants } from '../../../../../../constants';
import ModalCreateLocations from 'app/main/locations/ModalCreateLocationsQuarryPit';
import ModalCreateLocationsDestination from 'app/main/locations/ModalCreateLocationsDestination';
import AddIcon from '@mui/icons-material/Add';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import RemoveIcon from '@mui/icons-material/Remove';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import { connect } from 'react-redux';
import client from 'client';
import store from 'app/store';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TicketScaleImageUploader from '../../../../Ticket_jobs/TicketScaleImageUploader';
import moment from 'moment';
import useOpenImagePreview from 'app/hooks/useOpenImagePreview';
import ImageAnnotation from '../../../../CustomComponents/ImageAnnotation/ImageAnnotation';
import ButtonLog from 'app/main/ButtonLog';
import FilePreview from './FilePreview';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ViewBolImagesPreview from './ViewBolImagesPreview';
import { keyframes } from '@mui/system';
import ModalToEditCustomers from 'app/main/Customers/NewCustomersComponents/ModalToEditCustomers';
import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import CircularLoader from 'app/main/loadz/components/CircularLoader';
import {
  buildLocationAuditPayload,
  getLocationAuditValidationMessage,
  resolveLocationCompanyId,
  resolveLocationUpdatedBy,
} from 'utils/locationAuditFields';

const notificationLanguages = [
  { id: 'en', title: 'English', flag: 'us' },
  { id: 'mx', title: 'Español', flag: 'mx' },
];

function CreateJob({
  jsonGetById,
  user,
  setJob_id,
  setEditJobBillingOpen,
  setEditJobOpen,
  job_id,
  prop_data,
  onChangeText,
  setOnChangeText,
  onInputText,
  setOnInputText,
  bolJob,
  setBolJob,
  bolImage,
  setBolImage,
  setJsonGetById,
  fakeLoad
}) {

  useEffect(() => {
    //after a minute clear the job duplicate local storage
    if(localStorage.getItem('job_duplicate'))
    {
      const jobDuplicateDate = localStorage.getItem('job_duplicate_date');
      const new_jobDuplicateDate = moment(jobDuplicateDate).add(5, 'minute').format();
      if( moment().isSame(new_jobDuplicateDate) || moment().isAfter(new_jobDuplicateDate)) 
      {
        localStorage.removeItem('job_duplicate');
        localStorage.removeItem('job_duplicate_date');
      }
      else
      {
        setJsonGetById(localStorage.getItem('job_duplicate') ? JSON.parse(localStorage.getItem('job_duplicate')) : []);
      }
    }
  },[])

  const { t } = useTranslation('navigation');
  const { handlePreview } = useOpenImagePreview();
  const [locations, setLocations] = useState([]);
  const [locationsDestination, setLocationsDestination] = useState([]);
  const [locationsOrigin, setLocationsOrigin] = useState([]);
  const [locationStatus, setLocationStatus] = useState(true);
  const [locationsDesi, setLocationsDesi] = useState([]);
  const [createCustomer, setCreateCustomer] = useState(false);
  const [waypoint, setWaypoint] = useState([]);
  const [createLocation, setCreateLocation] = useState(false);
  const [createLocationDes, setCreateLocationDes] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLocation, setIsOpenLocation] = useState(false);
  const [isOpenLocationDesi, setIsOpenLocationDesi] = useState(false);
  const [isOpenLocationDes, setIsOpenLocationDes] = useState(false);
  const [verd, setverd] = useState();
  const [updateOrigin, setUpdateOrigin] = useState(false);
  const [updateOriginhidden, setUpdateOriginHidden] = useState(false);
  const [openDeleteLocationDialog, setOpenDeleteLocationDialog] = useState(false);
  const [locationToDelete, setLocationToDelete] = useState(null);
  const [originAutocompleteKey, setOriginAutocompleteKey] = useState(0);
  const [destinationAutocompleteKey, setDestinationAutocompleteKey] = useState(0);
  const [customers, setCustomers] = useState([]);
  const token = localStorage.token;
  const [locationQuarry, setLocationQuarry] = useState(null);
  const [locationDestination, setLocationDestination] = useState(null);
  const [checkDesi, setCheckDesi] = useState(false);
  const dispatch = useDispatch();
  const [loadMap, setLoadMap] = useState(false);
  const [checked, setChecked] = useState(false);
  const [jobtype, setJobtype] = useState(null);
  const [data, setData] = useState(null);
  const [ltype, setLtype] = useState([]);
  const tooltipAlert = ltype.l_type;
  const [origin, setOrigin] = useState([]);
  const [customerId, setCustomerId] = useState([]);
  const methods = useFormContext();
  const { control, formState, setValue, getValues, setError } = methods;
  const { errors } = formState;
  const [scale, setScale] = useState(
    jsonGetById && jsonGetById.length > 0
      ? jsonGetById?.[0]?.scale
        ? true
        : false
      : user?.company?.use_tk_scale
        ? true
        : false
  );
  const [showCustName, setShowCustName] = useState(
    jsonGetById && jsonGetById.length > 0
      ? jsonGetById?.[0]?.job_show_cust_on_tks
        ? true
        : false
      : user?.company?.show_cust_on_tks
        ? true
        : false
  );
  const [showTicketPicture, setShowTicketPicture] = useState(false);
  const [disableTicketBatching, setDisableTicketBatching] = useState(false);
  const [idlocations, setIdlocations] = useState();
  const history = useHistory();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      full_warning: false,
      fulf_total: false,
      first_load: false,
      delays: false,
      warn_loaded: false,
      warn_delivered: true,
      name: '',
      email: '',
      phone: '',
      notification_language: 'en', // idioma por defecto
    },
  ]);

  const [scaleImageRequired, setScaleImageRequired] = useState(false);

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        (i[event.target.name] = event.target.value),
          (i[event.target.email] = event.target.value),
          (i[event.target.phone] = event.target.value);
        if (!i.notification_language) i.notification_language = 'en';
      }
      return i;
    });
    setInputFields(newInputFields);
    setValue('notification', newInputFields);
  };

  const handleChangeInputwarning = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.full_warning = event.target.checked;
      }
      setInputFields([
        ...inputFields,
        {
          id: uuidv4(),
          full_warning: false,
          fulf_total: false,
          first_load: false,
          delays: false,
          name: '',
          email: '',
          phone: '',
          notification_language: 'en',
        },
      ]);
      setValue('notification', inputFields);
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputfulf_total = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.fulf_total = event.target.checked;
      }
      setInputFields([
        ...inputFields,
        {
          id: uuidv4(),
          full_warning: false,
          fulf_total: false,
          first_load: false,
          delays: false,
          warn_loaded: false,
          warn_delivered: true,
          name: '',
          email: '',
          phone: '',
          notification_language: 'en',
        },
      ]);
      setValue('notification', inputFields);
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputfirst_load = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.first_load = event.target.checked;
      }
      setInputFields([
        ...inputFields,
        {
          id: uuidv4(),
          full_warning: false,
          fulf_total: false,
          first_load: false,
          delays: false,
          warn_loaded: false,
          warn_delivered: true,
          name: '',
          email: '',
          phone: '',
          notification_language: 'en',
        },
      ]);
      setValue('notification', inputFields);
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputdelays = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.delays = event.target.checked;
      }
      setInputFields([
        ...inputFields,
        {
          id: uuidv4(),
          full_warning: false,
          fulf_total: false,
          first_load: false,
          delays: false,
          warn_loaded: false,
          warn_delivered: true,
          name: '',
          email: '',
          phone: '',
          notification_language: 'en',
        },
      ]);
      setValue('notification', inputFields);
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputWarnLoaded = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.warn_loaded = event.target.checked;
      }
      setInputFields([
        ...inputFields,
        {
          id: uuidv4(),
          full_warning: false,
          fulf_total: false,
          first_load: false,
          delays: false,
          warn_loaded: false,
          warn_delivered: true,
          name: '',
          email: '',
          phone: '',
          notification_language: 'en',
        },
      ]);
      setValue('notification', inputFields);
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputWarnDelivered = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.warn_delivered = event.target.checked;
      }
      setInputFields([
        ...inputFields,
        {
          id: uuidv4(),
          full_warning: false,
          fulf_total: false,
          first_load: false,
          delays: false,
          warn_loaded: false,
          warn_delivered: true,
          name: '',
          email: '',
          phone: '',
          notification_language: 'en',
        },
      ]);
      setValue('notification', inputFields);
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        full_warning: false,
        fulf_total: false,
        first_load: false,
        delays: false,
        warn_loaded: false,
        warn_delivered: true,
        name: '',
        email: '',
        phone: '',
        notification_language: 'en',
      },
    ]);
    setValue('notification', inputFields);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    setValue('notification', values);
  };

  const _showMessage = (msg, color) => {
    dispatch(
      showMessage({
        message: msg, //text or html
        autoHideDuration: 6000, //ms
        anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
        },
        variant: color, //success error info warning null
      })
    );
  };

  const getAllCustomers = async () => {
    let customer = [];
    try {
      const _customers = await client.get(`/customers/${prop_data?.id}`);
      const jsonCustomers = await _customers.data;

      customer = jsonCustomers.map((e) => {
        return { value: e.customers_id, label: e.customer_name };
      });
      customer.unshift({ value: 0, label: t('CREATE_CUSTOMER') });
      setCustomers(customer);
    } catch (error) {
      console.log(error);
      customer = [{ value: 0, label: t('CREATE_CUSTOMER') }];
    }
  };

  const getAllLocations = async () => {
    const { user_id: id } = user;
    let loca = [];
    let desti = [];
    try {
      const _locations = await client.post(`/locations/all`, {
        id: prop_data ? prop_data?.id : id,
      });
      const _locationsDesi = await client.post(`/locations/locations-desitination/all`, {
        id: prop_data?.id ? prop_data?.id : id,
      });
      const jsonLocations = await _locations.data;
      const jsonLocationsDesi = await _locationsDesi.data;
      setLocationsOrigin(jsonLocations);
      setLocationsDesi(jsonLocationsDesi);
      loca = [];
      desti = [];

      let filter = jsonLocations.filter((e) => e.l_type.includes('Quarry Pit'));
      let filterDestination = jsonLocationsDesi.filter((e) => e.l_type.includes('Destination'));

      loca = filter.map((e) => {
        return {
          value: e && e.l_id ? e.l_id : null,
          label: e.l_name,
          type: e.l_type,
          template:
            e?.scale_template_img && JSON.parse(e?.scale_template_img).length > 0 ? true : false,
        };
      });

      const startsWithNumber = (label) => /^\d/.test((label || '').trim());
      const leadingNumber = (label) => {
        const match = (label || '').trim().match(/^(\d+(?:\.\d+)?)/);
        return match ? Number(match[1]) : Infinity;
      };

      loca.sort((a, b) => {
        const aStartsWithNumber = startsWithNumber(a.label);
        const bStartsWithNumber = startsWithNumber(b.label);

        if (aStartsWithNumber && bStartsWithNumber) {
          const numberDiff = leadingNumber(a.label) - leadingNumber(b.label);
          if (numberDiff !== 0) {
            return numberDiff;
          }
          return (a.label || '').localeCompare(b.label || '', undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        }

        if (aStartsWithNumber) {
          return -1;
        }
        if (bStartsWithNumber) {
          return 1;
        }

        return (a.label || '').localeCompare(b.label || '', undefined, {
          sensitivity: 'base',
        });
      });

      desti = filterDestination.map((e) => {
        return { value: e && e.l_id ? e.l_id : null, label: e.l_name };
      });

      desti.sort((a, b) => {
        const aStartsWithNumber = startsWithNumber(a.label);
        const bStartsWithNumber = startsWithNumber(b.label);

        if (aStartsWithNumber && bStartsWithNumber) {
          const numberDiff = leadingNumber(a.label) - leadingNumber(b.label);
          if (numberDiff !== 0) {
            return numberDiff;
          }
          return (a.label || '').localeCompare(b.label || '', undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        }

        if (aStartsWithNumber) {
          return -1;
        }
        if (bStartsWithNumber) {
          return 1;
        }

        return (a.label || '').localeCompare(b.label || '', undefined, {
          sensitivity: 'base',
        });
      });

      loca.unshift({ value: 0, label: t('CREATE_LOCATION'), template: false });
      desti.unshift({ value: 0, label: t('CREATE_DESTINATION') });
      setLocations(loca);
      setLocationsDestination(desti);
    } catch (error) {
      loca = [{ value: 0, label: t('CREATE_LOCATION'), template: false }];
      desti = [{ value: 0, label: t('CREATE_DESTINATION') }];
      setLocations(loca);
      setLocationsDestination(desti);
    }
  };

  const handleCreateLocationOrigin = async (lname) => {
    const l_name = getValues('quarry_pit')?.[0]
      ? getValues('quarry_pit')?.[0]
      : origin?.length
        ? origin
        : lname;

    if (!l_name) {
      _showMessage(t('PLEASE_SELECT_LOCATION'), 'error');
      return;
    }
    try {
      const authUser = store.getState().loadz_auth?.AuthReducer?.user;
      const { company_id, updated_by } = buildLocationAuditPayload(authUser, prop_data, {
        l_name,
      });
      const validationMsg = getLocationAuditValidationMessage(company_id, updated_by);
      if (validationMsg) {
        _showMessage(validationMsg, 'error');
        return;
      }
      const response = await client.post(`${constants.URLLOCAL}/locations/${company_id}`, {
        l_name,
        company_id,
        updated_by,
      });
      const res = await response.data;
      setUpdateOriginHidden(false);
      if (res && res.l_id) {
        setValue('quarry_pit', [
          {
            value: res ? res.l_id : null,
            label: res ? res.l_name : null,
            type: res ? res.l_type : null,
          },
        ]);
        setLtype(res);
      }

      if (res.error) {
        _showMessage(t('FAILED_TO_UPDATE_ORIGIN_LOCATION_MESSAGE'), 'error'); //TODO Improved Message
        return;
      }
      _showMessage(t('ORIGIN_QUARRY_PIT_LOCATION_SUCCESSFULLY_UPDATED'), 'success'); //TODO Improved Message
      setUpdateOrigin(true);
    } catch (error) {
      _showMessage(t('FAILED_TO_UPDATE_ORIGIN_LOCATION_MESSAGE'), 'error'); //TODO Improved Message
    }
  };

  const handleCreateLocationDestination = async () => {
    try {
      setValue('l_type', t('DESTINATION'));
      setValue('l_name', onInputText);
      const authUser = store.getState().loadz_auth?.AuthReducer?.user;
      const payload = buildLocationAuditPayload(authUser, prop_data, getValues());
      const validationMsg = getLocationAuditValidationMessage(
        payload.company_id,
        payload.updated_by
      );
      if (validationMsg) {
        _showMessage(validationMsg, 'error');
        return;
      }
      const response = await client.post(`/locations/${payload.company_id}`, payload);
      const res = await response.data;

      setDestiAutoComplete(res.l_name);
      // setLocationsDestination({ value: res.l_id, label: res.l_name });
      setOnInputText(res.l_name);
      setOnChangeText(res.l_name);
      setLocationDestination({
        name: res.l_name,
        lat: res.l_latitude,
        lng: res.l_longitude,
        l_id: res.l_id,
        company_id: null,
      });

      if (res && res.l_id) {
        setIdlocations(res.l_id);
        setValue('j_destination', res.l_id);
      }

      if (res.error) {
        setverd(true);
        _showMessage(t('FAILED_TO_ADD_OR_UPDATE_DESTINATION_LOCATION_MESSAGE'), 'error');
        return;
      }
      _showMessage(t('DESTINATION_LOCATION_SUCCESSFULLY_UPDATED'), 'success');

      setverd(true);
    } catch (error) {
      setverd(true);
      _showMessage(t('UNEXPEXTED_ERROR_WHILE_PROCESSING_DESTINATION_MESSAGE'), 'error');
    }
  };

  const handleChange = (event) => {
    setChecked(checked ? false : true);
    setValue('visibility', checked);
  };

  const handle = (e) => {
    setValue('scale', e.target.checked);
    setScale(e.target.checked);
  };

  const handleShow = (e) => {
    setValue('job_show_cust_on_tks', e.target.checked);
    setShowCustName(e.target.checked);
  };

  const handleScaleImageRequired = (e) => {
    setValue('scale_image_required', e.target.checked);
    setScaleImageRequired(e.target.checked);
  };

  const handleTicketPicture = (e) => {
    setValue('job_picture_ticket', e.target.checked);
    setShowTicketPicture(e.target.checked);
  };
  const handleDisableTicket = (e) => {
    setValue('job_disable_batching_ticket', e.target.checked);
    setDisableTicketBatching(e.target.checked);
  };

  useEffect(async () => {
    getAllCustomers();
    getAllLocations();

    if (jsonGetById.length > 0) {
      const {
        customer_name,
        customers_id,
        j_destination,
        j_fullfillment_total,
        j_fullfillment_warning,
        j_notes,
        j_notes_drivers,
        j_origin,
        quarry_pit,
        visibility,
        po,
        scale,
        notification,
        job_type,
        job_show_cust_on_tks,
        require_scale_ticket,
        auto_batch,
        client_id
      } = jsonGetById[0];
      setJobtype(job_type);

      setValue('job_c_id', []);

      if (jsonGetById[0]) {
        console.log('jsonGetById[0]', jsonGetById[0]);
        setBolJob(jsonGetById[0]?.bol_type ? true : false);
        if (jsonGetById[0]?.bol_type) {
          console.log('jsonGetById[0]?.bol_file', jsonGetById[0]?.bol_file);
          setBolImage(
            jsonGetById[0]?.bol_file?.filter((file) => !file.key.toLowerCase().includes('pdf'))
          );
        }
        setValue('job_c_id', [{ value: customers_id ? customers_id : client_id, label: customer_name }]);
        setValue('quarry_pit', [
          {
            value: quarry_pit ? quarry_pit.l_id : j_origin.l_id,
            label: quarry_pit ? quarry_pit.l_name : j_origin.l_name,
            type: quarry_pit ? quarry_pit.l_type : j_origin.l_type,
          },
        ]);
        setValue('j_fullfillment_warning', j_fullfillment_warning);
        setValue('j_fullfillment_total', j_fullfillment_total);
        setValue('po', po);
        setIdlocations(j_destination && j_destination.l_id ? j_destination.l_id : null);
        setLtype(quarry_pit);
        setValue('scale', scale);
        setValue('job_show_cust_on_tks', job_show_cust_on_tks);
        setValue('job_picture_ticket', require_scale_ticket);
        setValue('job_disable_batching_ticket', auto_batch);
        setShowTicketPicture(require_scale_ticket);
        setDisableTicketBatching(auto_batch);
        setScale(scale);
        setValue('j_notes', j_notes);
        setValue('j_notes_drivers', j_notes_drivers);
        setverd(true);
        setUpdateOrigin(true);
        setValue('j_destination', j_destination && j_destination.l_id ? j_destination.l_id : null);
        setValue('l_name', j_destination.l_name);
        setChecked(visibility ? false : true);
        setOnInputText(j_destination.l_name);
        setOnChangeText(j_destination.l_name);
        setValue('order_pickup_id', jsonGetById[0]?.order_pickup_id);

        setValue('scale_image_required', jsonGetById[0]?.scale_image_required ? true : false);
        setScaleImageRequired(jsonGetById[0]?.scale_image_required ? true : false);

        if (notification.length >= 1) {
          setInputFields(notification);
          setValue('notification', notification);
        }

        setTimeout(() => {
          setLocationQuarry({
            name: quarry_pit ? quarry_pit.l_name : j_origin.l_name,
            lat: quarry_pit ? quarry_pit.l_latitude : j_origin.l_latitude,
            lng: quarry_pit ? quarry_pit.l_longitude : j_origin.l_longitude,
          });
          setLocationDestination({
            name: j_destination.l_name,
            lat: j_destination.l_latitude,
            lng: j_destination.l_longitude,
            l_id: j_destination.l_id,
            company_id: j_destination.company_id,
          });
        }, 2000);
      }
    } else {
      setValue(
        'scale',
        jsonGetById && jsonGetById.length > 0
          ? jsonGetById?.[0]?.scale
            ? true
            : false
          : user?.company?.use_tk_scale
            ? true
            : false
      );
      setValue(
        'job_show_cust_on_tks',
        jsonGetById && jsonGetById.length > 0
          ? jsonGetById?.[0]?.job_show_cust_on_tks
            ? true
            : false
          : user?.company?.show_cust_on_tks
            ? true
            : false
      );
    }
  }, [jsonGetById]);

  useEffect(() => {
    setIsOpen(false);
    if (createCustomer) {
      setIsOpen(true);
      //setValue('job_c_id', []);
    }
  }, [createCustomer]);

  useEffect(async () => {
    !isOpen ? setCreateCustomer(false) : null;
    getAllCustomers();
  }, [isOpen]);

  useEffect(() => {
    setIsOpenLocation(false);
    if (createLocation) {
      setIsOpenLocation(true);
      setValue('quarry_pit', []);
    }
  }, [createLocation]);

  useEffect(() => {
    setIsOpenLocationDes(false);
    if (createLocationDes) {
      setIsOpenLocationDes(true);
      setValue('quarry_pit', []);
    }
  }, [createLocationDes]);

  useEffect(async () => {
    !isOpenLocationDes ? setCreateLocationDes(false) : null;
    getAllLocations();
  }, [isOpenLocationDes]);

  useEffect(async () => {
    !isOpenLocation ? setCreateLocation(false) : null;
    getAllLocations();

    if (isOpenLocation == false) {
      if (data) {
        setValue('quarry_pit', [
          { value: data ? data.l_id : null, label: data ? data.l_name : null, type: data.l_type },
        ]);
        setLtype(data);
        setLocationQuarry({
          name: data.l_name,
          lat: data.l_latitude,
          lng: data.l_longitude,
          l_Address: data.l_address,
          l_City: data.l_city,
          l_State: data.l_state,
          l_Type: data.l_type,
        });
      }
    }
  }, [isOpenLocation, data]);

  const openDestination = (event) => {
    setIsOpenLocationDes(true);
    setCheckDesi(true);
    if (createLocationDes) {
      setIsOpenLocationDes(true);
    }
    !isOpenLocationDes ? setCreateLocationDes(false) : null;
  };

  const openOrigin = (event) => {
    setIsOpenLocation(true);
  };

  const setNewDestinationLocation = (data) => {
    setValue('l_name', data ? data.name : null);
    setDestiAutoComplete(data ? data.name : null);
    setIdlocations(data ? data.l_id : null);
    setLocationDestination(data);
  };

  useEffect(() => {
    if (locationDestination) {
      setValue('l_name', locationDestination ? locationDestination.name : null);
      setOnChangeText(locationDestination ? locationDestination.name : null);
      setOnInputText(locationDestination ? locationDestination.name : null);
    }
  }, [locationDestination]);

  const [destiAutoComplete, setDestiAutoComplete] = useState(null);

  useEffect(() => {
    setDestiAutoComplete(getValues('l_name'));
  }, [getValues('l_name')]);

  useEffect(() => {
    setValue('j_destination', idlocations);
  }, [idlocations]);

  const handleKeyPress = (e) => {
    setOrigin(e.target.value);
    handleCreateLocationOrigin(e.target.value);
    setUpdateOriginHidden(false);
  };

  const handleKeyPressDestination = (e) => {
    handleCreateLocationDestination();
  };

  const [jTotal, setJTotal] = useState('');

  const [bolUpload, setBolUpload] = useState(false);

  const handleScaleAddImage = (img = []) => {
    //account for array of images
    //console.log(img)
    if (Array.isArray(img) && img.length > 0) {
      const img_arrays = img.map((i) => {
        return { key: i, id: uuidv4(), date: moment().format() };
      });

      if (Array.isArray(bolImage) && bolImage.length > 0) {
        setBolImage([...bolImage, ...img_arrays]);
      } else {
        setBolImage([...img_arrays]);
      }
    } else {
      if (Array.isArray(bolImage) && bolImage.length > 0) {
        setBolImage([...bolImage, { key: img, id: uuidv4(), date: moment().format() }]);
      } else {
        setBolImage([{ key: img, id: uuidv4(), date: moment().format() }]);
      }
    }
  };

  const [openAnnotation, setOpenAnnotation] = useState(false);
  const [imageData, setImageData] = useState(null); //image data for annotation

  const createButtonLog = async (button_type) => {
    try {
      const data = {
        button_name: `image_annotation_bol_job_${button_type}`,
        type: 'image_annotation_bol_job',
        info: `image annotation in bol job module ${button_type}, image id: ` + imageData.id,
      };
      await ButtonLog(data);
    } catch (error) {
      console.log('BUTTON LOG CONTINUE ERROR: ', error);
    }
  };

  const handleClose = () => {
    setOpenAnnotation(false);
    setImageData(null);
    setImageIndex(null);
  };

  const saveAnnotations = (annotations) => {
    console.log('saveAnnotation: ');
    console.log(annotations);

    const new_imgs = JSON.parse(JSON.stringify(bolImage));
    console.log('new_imgs: ', new_imgs);
    if (new_imgs[imageIndex]?.annotations) {
      new_imgs[imageIndex].annotations = [];
      new_imgs[imageIndex].annotations = annotations;
    } else {
      new_imgs[imageIndex].annotations = annotations;
    }
    setBolImage(new_imgs);
  };
  const phoneregex = /^[0-9+\-\s()]*$/;

  // Función para formatear el número de teléfono
  const formatPhoneNumber = (value) => {
    // Eliminar todos los caracteres no numéricos
    const cleaned = value.replace(/\D/g, '');

    // Si no hay números, retornar vacío
    if (!cleaned.length) return '';

    // Formatear según el largo del número
    if (cleaned.length <= 10) {
      return cleaned;
    }

    return cleaned.slice(0, 10); // Limitar a 10 dígitos
  };

  const [viewBolImagePreview, setViewBolImagePreview] = useState(false);
  const [imageIndex, setImageIndex] = useState(null);

  const deleteBolImage = (index) => {
    const new_imgs = JSON.parse(JSON.stringify(bolImage));
    new_imgs.splice(index, 1);

    if (new_imgs.length <= 0) {
      setBolImage(null);
    } else {
      setBolImage(new_imgs);
    }
  };

  const pulse = keyframes`
  0% {
    box-shadow: 0 0 10px 2px #edca33;
  }
  50% {
    box-shadow: 0 0 20px 4px #edca33;
  }
  100% {
    box-shadow: 0 0 10px 2px #edca33;
  }
`;
  const openModalCustomer = useRef(null);
  const [create, setCreate] = useState(false);
  const handleClick = () => {
    setCreate(true);
    openModalCustomer.current(true);
  };
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [languageMenus, setLanguageMenus] = useState({});

  const handleLanguageMenuOpen = (id, event) => {
    setLanguageMenus((prev) => ({ ...prev, [id]: event.currentTarget }));
  };
  const handleLanguageMenuClose = (id) => {
    setLanguageMenus((prev) => ({ ...prev, [id]: null }));
  };

  const handleOpenDeleteLocationDialog = (event, option, kind = 'origin') => {
    event.preventDefault();
    event.stopPropagation();
    setLocationToDelete({ ...option, _kind: kind });
    setOpenDeleteLocationDialog(true);
  };

  const handleOpenEditLocationDialog = (event, option) => {
    event.preventDefault();
    event.stopPropagation();
    const location = locationsOrigin.find((loc) => loc && loc.l_id === option.value);
    if (!location) {
      return;
    }
    setLtype(location);
    setIsOpenLocation(true);
  };

  const handleOpenEditDestinationDialog = (event, option) => {
    event.preventDefault();
    event.stopPropagation();
    const location = locationsDesi.find((loc) => loc && loc.l_id === option.value);
    if (!location) {
      return;
    }
    setLocationDestination({
      name: location.l_name,
      lat: location.l_latitude,
      lng: location.l_longitude,
      l_address: location.l_address,
      l_city: location.l_city,
      l_state: location.l_state,
      l_type: location.l_type,
      l_zip: location.l_zip,
      l_id: location.l_id,
      company_id: location.company_id,
    });
    setIdlocations(location.l_id);
    setDestiAutoComplete(location.l_name);
    setOnChangeText(location.l_name);
    setOnInputText(location.l_name);
    setValue('l_name', location.l_name);
    setIsOpenLocationDes(true);
  };

  const handleCloseDeleteLocationDialog = () => {
    setOpenDeleteLocationDialog(false);
    setLocationToDelete(null);
  };

  const handleConfirmDeleteLocation = async () => {
    if (!locationToDelete?.value) {
      handleCloseDeleteLocationDialog();
      return;
    }
    try {
      const authUser = store.getState().loadz_auth?.AuthReducer?.user;
      const company_id = resolveLocationCompanyId(authUser, prop_data);
      const deleted_by = resolveLocationUpdatedBy(authUser);
      const validationMsg = getLocationAuditValidationMessage(company_id, deleted_by);
      if (validationMsg) {
        _showMessage(validationMsg, 'error');
        return;
      }

      await client.delete(`/locations/${locationToDelete.value}`, {
        data: {
          company_id,
          deleted_by,
        },
      });

      // Always clear the field after delete so typed search text / selected value
      // does not remain visible in freeSolo Autocomplete inputs.
      if (locationToDelete._kind === 'destination') {
        setLocationDestination(null);
        setIdlocations(null);
        setDestiAutoComplete(null);
        setOnChangeText('');
        setOnInputText('');
        setValue('l_name', null);
        setValue('j_destination', null);
        setDestinationAutocompleteKey((key) => key + 1);
      } else {
        setValue('quarry_pit', []);
        setLocationQuarry(null);
        setOrigin('');
        setLtype([]);
        setUpdateOriginHidden(false);
        setUpdateOrigin(false);
        setOriginAutocompleteKey((key) => key + 1);
      }
      await getAllLocations();
      _showMessage(t('RECORD_DELETED_SUCCESSFULLY'), 'success');
    } catch (error) {
      console.log(error);
      _showMessage(t('UNEXPEXTED_ERROR_WHILE_PROCESSING_DESTINATION_MESSAGE'), 'error');
    } finally {
      handleCloseDeleteLocationDialog();
    }
  };

  const handleNotificationLanguageChange = (inputField, lang) => {
    const newInputFields = inputFields.map((i) => {
      if (i.id === inputField.id) {
        i.notification_language = lang.id;
      }
      return i;
    });
    setInputFields(newInputFields);
    setValue('notification', newInputFields);
    handleLanguageMenuClose(inputField.id);
  };

  return (
    <div>
      <Dialog open={fakeLoad}
        fullScreen
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}>
          <div className='flex flex-row items-center align-center justify-center w-full h-full'>
            <CircularLoader/>
          </div>
          
      </Dialog>

      <Dialog
        open={openDeleteLocationDialog}
        onClose={handleCloseDeleteLocationDialog}
        maxWidth='xs'
        fullWidth
      >
        <DialogTitle>
          {t('ARE_YOU_SURE_YOU_WANT_TO_DELETE')}{' '}
          {locationToDelete?.label ? `"${locationToDelete.label}"` : ''}?
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              fontSize: '1.15rem',
              fontWeight: 700,
              color: 'error.main',
              textAlign: 'center',
            }}
          >
            {t('THIS_ACTION_IS_PERMANENT_AND_CANNOT_BE_UNDONE')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteLocationDialog} color='inherit'>
            Cancel
          </Button>
          <Button onClick={handleConfirmDeleteLocation} color='error' variant='contained' autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      <ViewBolImagesPreview
        open={viewBolImagePreview}
        closePreview={setViewBolImagePreview}
        images={bolImage}
        setImageIndex={setImageIndex}
        deleteImage={deleteBolImage}
        setBolUpload={setBolUpload}
        setImageData={setImageData}
        setOpenAnnotation={setOpenAnnotation}
        jobtype={jobtype}
      />

      <ImageAnnotation
        open={openAnnotation}
        handleClose={handleClose}
        saveAnnotations={saveAnnotations}
        imageData={imageData}
        createButtonLog={createButtonLog}
        formType={'bol'}
      />

      <TicketScaleImageUploader
        user={store.getState().loadz_auth.AuthReducer.user}
        handleAddEditScaleImage={handleScaleAddImage}
        open={bolUpload}
        setOpen={setBolUpload}
        type={'bol'}
        fileTypes={['JPEG', 'PNG', 'JPG', 'PDF']}
      />

      <ModalToEditCustomers
        refreshCustomers={getAllCustomers} // Pass the actual function
        id={null}
        setOpen={openModalCustomer}
        rechargedAfterChanges={null}
        create={create}
        setSelectedCustomer={setSelectedCustomer}
        setCustomerId={setCustomerId}
      />
      {/* <ModalCreateCustomer
        data={prop_data}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      ></ModalCreateCustomer> */}

      <ModalCreateLocations
        company_id={
          prop_data?.id || store.getState().loadz_auth?.AuthReducer?.user?.user_id
        }
        data={prop_data}
        isOpen={isOpenLocation}
        setIsOpen={setIsOpenLocation}
        setData={setData}
        info={ltype}
        setLocationStatus={setLocationStatus}
      ></ModalCreateLocations>

      <ModalCreateLocationsDestination
        company_id={
          prop_data?.id || store.getState().loadz_auth?.AuthReducer?.user?.user_id
        }
        id={idlocations}
        isOpen={isOpenLocationDes}
        setIsOpen={setIsOpenLocationDes}
        setNewLocation={setNewDestinationLocation}
        locationDestination={locationDestination}
        querryPit={locationQuarry}
        checkDes={checkDesi}
        waypoint={waypoint}
      ></ModalCreateLocationsDestination>

      <div className='flex w-full max-w-screen-sx justify-center newjob mb-20'>
        <div className='w-1/2	newjob-form'>
          <div className='w-full flex mx-0 flex-row items-center px-5'>
            {jsonGetById.length <= 0 && jobtype != 'sub' && (
              <div className='mb-10 flex flex-row justify-start items-center align-center'>
                <Typography fontWeight={'bold'} className='font-Regular text-12'>
                  {t('BILL_OF_LADING')}
                </Typography>
                <Controller
                  name='visibility'
                  type='checkbox'
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Checkbox
                      disabled={jsonGetById.length > 0}
                      checked={bolJob}
                      onClick={(ev) => {
                        setBolJob(!bolJob);
                      }}
                    />
                  )}
                />
              </div>
            )}

            {jsonGetById.length > 0 && bolJob == true ? (
              <Typography fontWeight={'bold'} variant='h5'>
                {t('BILL_OF_LADING')}
              </Typography>
            ) : null}
          </div>
          <div
            className={`flex flex-row align-center jusitfy-center ${bolJob && bolImage ? 'items-start' : 'items-center'
              } flex-wrap`}
          >
            <div
              className={`${bolJob ? 'w-full md:w-1/2' : 'w-full md:3/5'
                }  flex mx-0 flex-wrap items-center`}
            >
              {jsonGetById.length > 0 && (
                <div className='mb-10 flex items-center px-8 w-full'>
                  <Typography className='font-Regular text-12'>{t('DISABLE_JOB')}</Typography>
                  <Controller
                    name='visibility'
                    type='checkbox'
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Checkbox
                        disabled={jobtype == 'sub' ? true : false}
                        checked={checked}
                        onClick={(ev) => {
                          handleChange(ev);
                        }}
                      />
                    )}
                  />
                </div>
              )}

              <Controller
                name='job_c_id'
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    disabled={jobtype == 'sub' ? true : false}
                    className={`${bolJob ? 'w-full' : 'w-full md:w-1/2'} mt-0 mb-0 customers px-8`}
                    multiple
                    freeSolo={value.length == 1 ? false : true}
                    getOptionDisabled={(options) => (value.length == 1 ? true : false)}
                    options={customers}
                    value={value}
                    onChange={(event, newValue) => {
                      setCreateCustomer(false);

                      newValue.map((r) => {
                        if (r.value == 0) {
                          handleClick();
                          //setCreateCustomer(true);
                        } else {
                          onChange(newValue);
                        }
                      });
                      if (!newValue.length) {
                        onChange(newValue);
                      }
                    }}
                    fullWidth
                    renderInput={(params) => (
                      <>
                        <InputLabel htmlFor='input-with-icon-adornment'>
                          {' '}
                          {t('SELECT_CUSTOMER')}{' '}
                        </InputLabel>
                        <TextField
                          disabled={jobtype == 'sub' ? true : false}
                          {...params}
                          autoFocus
                          id={'customers'}
                          placeholder={t('SELECT_CUSTOMER')}
                          className='w-full mt-2 mb-16 mx-0 margin-x-0'
                          variant='outlined'
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </>
                    )}
                    limitTags={1}
                  />
                )}
              />

              <div
                className={`${bolJob ? 'w-full' : 'w-full md:w-1/2'
                  }  flex-col mx-0 margin-x-0 px-8`}
              >
                <Controller
                  name='po'
                  control={control}
                  render={({ field }) => (
                    <>
                      <InputLabel htmlFor='input-with-icon-adornment'> {t('PURCHASE_ORDER')} </InputLabel>
                      <Tooltip
                        title={t('PURCHASE_ORDER_MESSAGE')}
                        placement='top'
                      >
                        <TextField
                          {...field}
                          disabled={jobtype == 'sub' ? true : false}
                          className='mt-2 mb-16 mx-0 margin-x-0'
                          id='po'
                          placeholder={t('PURCHASE_ORDER')}
                          fullWidth
                        />
                      </Tooltip>
                    </>
                  )}
                />
              </div>

              {jsonGetById && jsonGetById.length > 0 && !localStorage.getItem('job_duplicate') && (
                <TextField
                  className={`${bolJob ? 'w-full' : 'w-full md:w-1/2'} px-8`}
                  // sx={{paddingRight:jsonGetById[0]?.bol_type ? 5 : 0}}
                  placeholder={t('JOB_NO')}
                  type={'number'}
                  value={jsonGetById[0].job_no}
                  disabled={true}
                  variant='outlined'
                  fullWidth
                />
              )}

              {/**location fields */}
              {bolJob && bolImage ? (
                <div className='flex mx-0 flex-col w-full'>
                  <div className='w-full flex justify-center destination-right mt-8 mb-16 px-7'>
                    <div className='flex flex-col margin-x-0 w-full'>
                      <Controller
                        name='quarry_pit'
                        control={control}
                        render={({ field: { onChange, value } }) => (
                                                    <Autocomplete
                            key={`origin-autocomplete-bol-${originAutocompleteKey}`}
                            disabled={
                              jobtype == 'sub' ? true : !getValues('job_c_id').length ? true : false
                            }
                            freeSolo={true}
                            options={locations}
                            value={Array.isArray(value) && value.length > 0 ? value[0] : null}
                            onBlur={(e) => {
                              setOrigin(e.target.value);
                            }}
                            onInput={(e) => {
                              setOrigin(e.target.value);
                            }}
                            onChange={(event, newValue) => {
                              setCreateLocation(false);
                              setUpdateOriginHidden(false);
                              setUpdateOrigin(false);

                              if (!newValue) {
                                setLocationQuarry(null);
                                onChange([]);
                                return;
                              }

                              if (typeof newValue === 'string') {
                                setOrigin(newValue);
                                onChange([]);
                                return;
                              }

                              if (newValue.value == 0) {
                                setLtype([]);
                                setCreateLocation(true);
                                onChange([]);
                                return;
                              }

                              locationsOrigin.forEach((loc) => {
                                if (loc && loc.l_id === newValue.value) {
                                  setLocationQuarry({
                                    name: loc.l_name,
                                    lat: loc.l_latitude,
                                    lng: loc.l_longitude,
                                    l_Address: loc.l_address,
                                    l_City: loc.l_city,
                                    l_State: loc.l_state,
                                    l_Type: loc.l_type,
                                  });
                                  setLtype([]);
                                  setUpdateOriginHidden(true);
                                }
                              });
                              onChange([newValue]);
                            }}
                            fullWidth
                            getOptionLabel={(option) =>
                              typeof option === 'string' ? option : option?.label || ''
                            }
                            isOptionEqualToValue={(option, val) => {
                              if (typeof option === 'string' || typeof val === 'string') {
                                return option === val;
                              }
                              return option?.value === val?.value;
                            }}
                            renderOption={(props, option) => {
                              const index = locations.findIndex((loc) => loc.value === option.value);
                              return (
                                <li
                                  {...props}
                                  key={option.value ?? option.label}
                                  className='flex justify-between'
                                  style={{
                                    borderBottom: option.value === 0 ? '2px solid black' : 'none',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <span>{option.label}</span>
                                  <div className='flex flex-wrap items-center'>
                                    {option.value === 0 ? null : option.template ? (
                                      <Icon style={{ color: '#50c760', fontWeight: 'bold' }}>check</Icon>
                                    ) : (
                                      <>
                                        <DeleteForeverIcon
                                          style={{ color: 'red', marginRight: '8px', cursor: 'pointer' }}
                                          fontSize='small'
                                          onClick={(e) =>
                                            handleOpenDeleteLocationDialog(e, option, 'origin')
                                          }
                                        />
                                        <EditIcon
                                          style={{ color: 'blue', marginRight: '16px', cursor: 'pointer' }}
                                          fontSize='small'
                                          onClick={(e) => handleOpenEditLocationDialog(e, option)}
                                        />
                                      </>
                                    )}
                                    {index > 0 && option.template ? (
                                      <>
                                        <div>
                                          <Typography
                                            fontWeight={'bold'}
                                            fontSize={'6px'}
                                            sx={{ color: 'blue', marginRight: '2px' }}
                                          >
                                            {t('LOADZ_AI')}
                                          </Typography>
                                          <Typography
                                            fontWeight={'bold'}
                                            fontSize={'6px'}
                                            sx={{ color: 'blue', marginRight: '2px' }}
                                          >
                                            {t('ASSIST')}
                                          </Typography>
                                        </div>
                                        <AutoAwesomeIcon sx={{ color: 'blue' }} fontSize='6px' />
                                      </>
                                    ) : null}
                                  </div>
                                </li>
                              );
                            }}
                            renderInput={(params) => (
                              <>
                                <InputLabel htmlFor='input-with-icon-adornment'>
                                  {' '}
                                  {bolJob == false
                                    ? t('SELECT_QUARRY_PIT_MESSAGE')
                                    : t('CREATE_AN_ORIGIN')}{' '}
                                </InputLabel>
                                <TextField
                                  disabled={
                                    jobtype == 'sub'
                                      ? true
                                      : !getValues('job_c_id').length
                                        ? true
                                        : false
                                  }
                                  {...params}
                                  id={'locations'}
                                  placeholder={bolJob ? t('WHAREHOUSE') : t('SELECT_OR_CREATE_AN_ORIGIN')}
                                  className='mt-2 mb-0 mx-0 selectqp margin-x-0'
                                  variant='outlined'
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    ...params.inputProps,
                                    onKeyDown: (e) => {
                                      if (e.key === 'Enter') {
                                        // e.stopPropagation();
                                      }
                                    },
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Tab') {
                                      handleKeyPress(e);
                                    }
                                    if (e.key === 'Enter') {
                                      handleKeyPress(e);
                                    }
                                  }}
                                />
                              </>
                            )}
                          />
                        )}
                      />
                    </div>

                    {!updateOrigin && (
                      <>
                        {locationStatus ? null : (
                          <>
                            {tooltipAlert &&
                              tooltipAlert !== null &&
                              tooltipAlert !== undefined &&
                              tooltipAlert == 'Quarry Pit' ? null : (
                              <div
                                className='mt-8 mb-16 mx-0 margin-x-0 location-btn'
                                style={{ alignSelf: 'center' }}
                              >
                                <InputAdornment position='start'>
                                  <Tooltip
                                    title={
                                      tooltipAlert && tooltipAlert !== undefined
                                        ? `${t('UPDATE')} ${tooltipAlert}`
                                        : t('UPDATE_ORIGIN')
                                    }
                                  >
                                    <Fab
                                      disabled={
                                        jobtype == 'sub'
                                          ? true
                                          : !getValues('job_c_id').length
                                            ? true
                                            : false
                                      }
                                      color='primary'
                                      size='small'
                                      onClick={openOrigin}
                                      hidden={updateOriginhidden}
                                    >
                                      <EditLocationAltIcon />
                                    </Fab>
                                  </Tooltip>
                                </InputAdornment>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {updateOrigin && (
                      <>
                        {tooltipAlert &&
                          tooltipAlert !== null &&
                          tooltipAlert !== undefined &&
                          tooltipAlert == 'Quarry Pit' ? null : (
                          <div
                            className='mt-8 mb-16 mx-0 margin-x-0 location-btn'
                            style={{ alignSelf: 'center' }}
                          >
                            <InputAdornment position='start'>
                              <Tooltip
                                title={
                                  tooltipAlert && tooltipAlert !== undefined
                                    ? `${t('UPDATE')} ${tooltipAlert}`
                                    : t('UPDATE_ORIGIN')
                                }
                              >
                                <Fab
                                  disabled={
                                    jobtype == 'sub'
                                      ? true
                                      : !getValues('job_c_id').length
                                        ? true
                                        : false
                                  }
                                  color='primary'
                                  size='small'
                                  onClick={openOrigin}
                                  hidden={updateOriginhidden}
                                >
                                  <EditLocationAltIcon />
                                </Fab>
                              </Tooltip>
                            </InputAdornment>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  <div className='w-fullflex justify-center destination-right mt-8 mb-16 px-5 pl-10'>
                    <div className='flex flex-col margin-x-0 w-full'>
                      <Autocomplete
                        key={`destination-autocomplete-bol-${destinationAutocompleteKey}`}
                        disabled={jobtype == 'sub' ? true : false}
                        // disabled={
                        //   jobtype == 'sub'
                        //     ? true
                        //     : !locationQuarry || !getValues('quarry_pit').length
                        //     ? true
                        //     : false
                        // }
                        freeSolo={true}
                        value={destiAutoComplete}
                        options={locationsDestination}
                        // getOptionLabel={(option) => (option.label ? option.label : '')}
                        onInput={(e) => {
                          setOnInputText(e.target.value);

                          if (e.target.value != onChangeText) {
                            setIdlocations(null);
                            setLocationDestination(null);
                          }
                        }}
                        onChange={(event, newValue) => {
                          if (newValue && typeof newValue == 'object') {
                            newValue && newValue.label
                              ? setOnChangeText(newValue.label)
                              : setOnChangeText('');
                          }
                          if (newValue == null) {
                            setOnChangeText('');
                          }
                          if (newValue && typeof newValue == 'string') {
                            setOnChangeText(newValue);
                          }

                          setIdlocations(null);
                          setLocationDestination(null);
                          if (newValue) {
                            if (newValue.value == 0) {
                              setIsOpenLocationDes(true);
                              setValue('l_name', null);
                            }
                            if (newValue.value != 0) {
                              locationsDesi.forEach((loc) => {
                                if (loc && loc.l_id === newValue.value) {
                                  setLocationDestination({
                                    name: loc.l_name,
                                    lat: loc.l_latitude,
                                    lng: loc.l_longitude,
                                    l_address: loc.l_address,
                                    l_city: loc.l_city,
                                    l_state: loc.l_state,
                                    l_type: loc.l_type,
                                    l_zip: loc.l_zip,
                                    l_id: loc.l_id,
                                    company_id: loc.company_id,
                                  });
                                  setIdlocations(loc.l_id);
                                }
                              });
                              setValue('l_name', newValue.label);
                            }
                          } else {
                            setValue('l_name', null);
                          }
                        }}
                        fullWidth
                        getOptionLabel={(option) =>
                          typeof option === 'string' ? option : option?.label || ''
                        }
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            key={option.value ?? option.label}
                            className='flex justify-between'
                            style={{
                              padding: '8px 16px',
                              cursor: 'pointer',
                            }}
                          >
                            <span>{option.label}</span>
                            {option.value === 0 ? null : (
                              <div className='flex flex-wrap items-center'>
                                <DeleteForeverIcon
                                  style={{ color: 'red', marginRight: '8px', cursor: 'pointer' }}
                                  fontSize='small'
                                  onClick={(e) =>
                                    handleOpenDeleteLocationDialog(e, option, 'destination')
                                  }
                                />
                                <EditIcon
                                  style={{ color: 'blue', marginRight: '16px', cursor: 'pointer' }}
                                  fontSize='small'
                                  onClick={(e) => handleOpenEditDestinationDialog(e, option)}
                                />
                              </div>
                            )}
                          </li>
                        )}
                        renderInput={(params) => (
                          <>
                            <InputLabel htmlFor='input-with-icon-adornment'>{t('DESTINATION')}</InputLabel>
                            <TextField
                              disabled={jobtype == 'sub' ? true : false}
                              {...params}
                              inputProps={{
                                ...params.inputProps,
                                onKeyDown: (e) => {
                                  if (e.key === 'Enter') {
                                    // e.stopPropagation();
                                  }
                                },
                              }}
                              id={'locationsDestination'}
                              placeholder={t('DESTINATION')}
                              className='mt-2 mb-0 mx-0 selectqp margin-x-0'
                              variant='outlined'
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Tab') {
                                  handleKeyPressDestination(e);
                                }
                                if (e.key === 'Enter') {
                                  handleKeyPressDestination(e);
                                }
                              }}
                            />
                          </>
                        )}
                      />
                    </div>

                    {locationDestination ? (
                      <div
                        className='mt-8 mb-16 mx-0 margin-x-0 location-btn flex flex-row justify-end w-full pr-10'
                        style={{ alignSelf: 'center' }}
                      >
                        <InputAdornment position='start'>
                          <Tooltip title={t('UPDATE_DESTINATION')}>
                            <Fab
                              disabled={jobtype == 'sub' ? true : false}
                              color='primary'
                              size='small'
                              onClick={() => {
                                const resolvedCompanyId =
                                  locationDestination?.company_id ||
                                  prop_data?.id ||
                                  store.getState().loadz_auth?.AuthReducer?.user?.user_id;
                                if (locationDestination) {
                                  setLocationDestination({
                                    ...locationDestination,
                                    company_id: resolvedCompanyId,
                                  });
                                }
                                setIsOpenLocationDes(true);
                              }}
                            >
                              <EditLocationAltIcon />
                            </Fab>
                          </Tooltip>
                        </InputAdornment>
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}

              {/**order pick up number */}
              {bolJob && bolImage ? (
                <>
                  <div className={`w-full flex-col mx-0 margin-x-0 px-8`}>
                    <Controller
                      name='order_pickup_id'
                      control={control}
                      render={({ field }) => (
                        <>
                          <InputLabel htmlFor='input-with-icon-adornment'>
                            {' '}
                            {t('ORDER_PICKUP_NUMBER')}{' '}
                          </InputLabel>
                          <TextField
                            {...field}
                            className='mt-2 mb-16 mx-0 margin-x-0'
                            id='order_pickup_id'
                            placeholder={t('ORDER_PICKUP_NUMBER')}
                            fullWidth
                          />
                        </>
                      )}
                    />
                  </div>

                  <div className='w-1/2 flex flex-col mx-0 margin-x-0 px-5 pl-10 fullwidth'>
                    <Controller
                      name='j_notes_drivers'
                      control={control}
                      render={({ field }) => (
                        <>
                          <InputLabel htmlFor='input-with-icon-adornment'>
                            {' '}
                            {t('NOTES_FOR_DRIVER')}{' '}
                          </InputLabel>
                          <TextField
                            {...field}
                            disabled={jobtype == 'sub' ? true : false}
                            className='mt-2 mb-16 mx-0 margin-x-0'
                            id='j_notes_drivers'
                            // label='Notes'
                            placeholder={t('NOTES_FOR_DRIVER')}
                            error={!!errors.j_notes_drivers}
                            helperText={errors?.j_notes_drivers?.message}
                            multiline
                            fullWidth
                          />
                        </>
                      )}
                    />
                  </div>
                </>
              ) : null}
            </div>

            {bolJob && (
              <div className='w-full md:w-1/2 flex justify-center items-center my-8'>
                {
                  //image annotation
                  !bolImage ? (
                    <Box
                      onClick={() => {
                        setBolUpload(true);
                      }}
                      className='flex flex-col justify-center align-center items-center'
                      sx={{
                        border: 3,
                        height: '200px',
                        width: '200px',
                        borderRadius: 3,
                        borderColor: 'gray',
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='100px'
                        height='100px'
                        viewBox='0 0 172 149'
                        fill='none'
                      >
                        <g clip-path='url(#clip0_141_2095)'>
                          <path
                            d='M87.7472 54.6136C87.5441 54.3419 87.2804 54.1213 86.9771 53.9693C86.6738 53.8173 86.3392 53.7382 86 53.7382C85.6607 53.7382 85.3261 53.8173 85.0228 53.9693C84.7195 54.1213 84.4559 54.3419 84.2528 54.6136L56.3712 91.7765C56.1269 92.1003 55.9778 92.4858 55.9406 92.8897C55.9034 93.2936 55.9796 93.6998 56.1607 94.0628C56.3418 94.4257 56.6206 94.731 56.9657 94.9442C57.3109 95.1575 57.7086 95.2702 58.1143 95.2699H73.0645C73.6437 95.2699 74.1992 95.4993 74.6095 95.908C75.0198 96.3166 75.2514 96.8712 75.2535 97.4502V146.82C75.2525 147.107 75.3081 147.391 75.4172 147.657C75.5263 147.922 75.6868 148.163 75.8894 148.367C76.0921 148.57 76.3328 148.731 76.598 148.841C76.8631 148.951 77.1474 149.008 77.4345 149.008H94.5655C94.8526 149.008 95.1369 148.951 95.402 148.841C95.6671 148.731 95.9079 148.57 96.1105 148.367C96.3132 148.163 96.4736 147.922 96.5828 147.657C96.6919 147.391 96.7475 147.107 96.7464 146.82V97.4502C96.7486 96.8712 96.9802 96.3166 97.3904 95.908C97.8007 95.4993 98.3563 95.2699 98.9355 95.2699H113.886C114.291 95.2702 114.689 95.1575 115.034 94.9442C115.379 94.731 115.658 94.4257 115.839 94.0628C116.02 93.6998 116.097 93.2936 116.059 92.8897C116.022 92.4858 115.873 92.1003 115.629 91.7765L87.7472 54.6136Z'
                            fill='#BDBBBB'
                          />
                          <path
                            d='M154.188 51.412C153.089 50.6284 152.157 49.6333 151.447 48.4851C150.737 47.3369 150.263 46.0586 150.053 44.7251C148.278 32.8346 138.703 0 99.6814 0C79.0884 0 65.403 16.9482 62.5249 20.8388C62.1382 21.3625 61.6008 21.7556 60.9845 21.9654C60.4635 22.1457 59.904 22.1849 59.363 22.0789C54.612 21.1468 29.7545 13.3819 24.2009 43.2662C23.5359 46.5425 21.6452 49.4415 18.9148 51.3715C8.07509 59.2255 -0.00805664 71.8374 -0.00805664 85.9487C0.025205 96.2777 3.76391 106.252 10.5287 114.059C17.2934 121.866 26.6353 126.988 36.8566 128.494C38.2661 128.709 39.7033 128.355 40.852 127.511C42.0007 126.666 42.7668 125.4 42.9818 123.991C43.1968 122.582 42.8431 121.145 41.9985 119.997C41.1539 118.848 39.8876 118.082 38.4781 117.867C31.8555 116.94 25.6886 113.965 20.8401 109.361C15.9916 104.756 12.704 98.7518 11.4372 92.1873C10.1704 85.6227 10.9877 78.8265 13.7749 72.7493C16.5621 66.672 21.1797 61.6177 26.9817 58.2934C28.6711 57.3171 30.1297 55.9875 31.2575 54.3956C32.3853 52.8036 33.1558 50.9868 33.5163 49.0696C38.1538 23.3757 56.5416 33.5236 61.5276 36.8143C61.9113 37.0649 62.3422 37.2345 62.7937 37.3127C63.2453 37.3909 63.7081 37.376 64.1537 37.269C64.5994 37.162 65.0184 36.9651 65.3852 36.6904C65.752 36.4157 66.0588 36.069 66.2868 35.6715L69.6513 29.8032C76.5022 17.9046 88.6877 9.53995 102.122 10.7882C135.411 13.779 139.724 38.3462 139.935 49.5964C139.96 51.3522 140.437 53.0721 141.32 54.5898C142.203 56.1076 143.463 57.372 144.978 58.261V58.261C150.809 61.5727 155.454 66.6282 158.262 72.7166C161.069 78.8049 161.897 85.6199 160.629 92.2032C159.361 98.7864 156.061 104.807 151.193 109.418C146.325 114.028 140.133 116.998 133.49 117.908C132.08 118.123 130.814 118.889 129.969 120.037C129.125 121.186 128.771 122.622 128.986 124.032C129.201 125.441 129.967 126.707 131.116 127.551C132.264 128.395 133.702 128.749 135.111 128.534C143.577 127.349 151.494 123.657 157.842 117.933C164.19 112.21 168.678 104.717 170.728 96.4198C172.778 88.1231 172.295 79.4027 169.343 71.3824C166.391 63.3621 161.104 56.4094 154.164 51.4201L154.188 51.412Z'
                            fill='#BDBBBB'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_141_2095'>
                            <rect width='172' height='149' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      <Typography
                        fontWeight={'bold'}
                        fontSize={'16px'}
                        sx={{ color: 'gray', marginTop: 2 }}
                      >
                        {t('UPLOAD_BOL')}
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      onClick={() => {
                        console.log('bolImage: ', bolImage);
                        //setImageData({image:bolImage})
                        //setOpenAnnotation(true)
                        setViewBolImagePreview(true);
                      }}
                      className='flex flex-col justify-between align-center items-center relative w-full'
                      sx={{
                        border: 1,
                        borderRadius: 3,
                        borderColor: 'lightgray',
                        mx: '8px',
                        padding: 1,
                        position: 'relative',
                      }}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          top: 5,
                          right: 5,
                          backgroundColor: '#edca33',
                          color: 'black',
                          borderRadius: 10,
                          zIndex: 1,
                          padding: 3,
                        }}
                      >
                        <Typography fontWeight={'bold'} variant='body1'>
                          {bolImage?.length ? `+${bolImage.length}` : null}
                        </Typography>
                      </div>
                      {bolImage.length && bolImage[0]?.key && (
                        <FilePreview imageKey={bolImage[0].key} />
                      )}
                      <Box
                        display='flex'
                        alignItems='center'
                        justifyContent='center'
                        gap={2}
                        my={2}
                      >
                        {jobtype == 'sub' ? null : (
                          <Tooltip title={t('ADD_IMAGE')} placement='top'>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setBolUpload(true);
                              }}
                              sx={{
                                color: 'white',
                                backgroundColor: 'primary.main',
                                '&:hover': {
                                  backgroundColor: 'primary.dark',
                                },
                                boxShadow: 3,
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        )}

                        <Tooltip
                          title={t('REVIEW_IMAGES_TO_ADD_ANOTATIONS')}
                          placement='top'
                        >
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              //setImageData({ image: bolImage });
                              //setOpenAnnotation(true);
                              setViewBolImagePreview(true);
                            }}
                            sx={{
                              color: 'white',
                              backgroundColor: 'secondary.main',
                              '&:hover': {
                                backgroundColor: 'secondary.dark',
                              },
                              boxShadow: 3,
                              animation: bolImage?.some((img) =>
                                img.annotations?.some((ann) => ann?.data?.field === 'signature')
                              )
                                ? 'none'
                                : `${pulse} 2s infinite`,
                            }}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>
                  )
                }
              </div>
            )}
          </div>

          {/**Location fields origin/destination */}
          {bolJob && bolImage ? null : (
            <div className='flex mx-0 flex-wrap'>
              <div className='w-1/2 flex justify-center destination-right mt-8 mb-16 px-7'>
                <div className='flex flex-col margin-x-0 w-full'>
                  <Controller
                    name='quarry_pit'
                    control={control}
                    render={({ field: { onChange, value } }) => (
                                            <Autocomplete
                        key={`origin-autocomplete-${originAutocompleteKey}`}
                        disabled={
                          jobtype == 'sub' ? true : !getValues('job_c_id').length ? true : false
                        }
                        freeSolo={true}
                        options={locations}
                        value={Array.isArray(value) && value.length > 0 ? value[0] : null}
                        onBlur={(e) => {
                          setOrigin(e.target.value);
                        }}
                        onInput={(e) => {
                          setOrigin(e.target.value);
                        }}
                        onChange={(event, newValue) => {
                          setCreateLocation(false);
                          setUpdateOriginHidden(false);
                          setUpdateOrigin(false);

                          if (!newValue) {
                            setLocationQuarry(null);
                            onChange([]);
                            return;
                          }

                          if (typeof newValue === 'string') {
                            setOrigin(newValue);
                            onChange([]);
                            return;
                          }

                          if (newValue.value == 0) {
                            setLtype([]);
                            setCreateLocation(true);
                            onChange([]);
                            return;
                          }

                          locationsOrigin.forEach((loc) => {
                            if (loc && loc.l_id === newValue.value) {
                              setLocationQuarry({
                                name: loc.l_name,
                                lat: loc.l_latitude,
                                lng: loc.l_longitude,
                                l_Address: loc.l_address,
                                l_City: loc.l_city,
                                l_State: loc.l_state,
                                l_Type: loc.l_type,
                              });
                              setLtype([]);
                              setUpdateOriginHidden(true);
                            }
                          });
                          onChange([newValue]);
                        }}
                        fullWidth
                        getOptionLabel={(option) =>
                          typeof option === 'string' ? option : option?.label || ''
                        }
                        isOptionEqualToValue={(option, val) => {
                          if (typeof option === 'string' || typeof val === 'string') {
                            return option === val;
                          }
                          return option?.value === val?.value;
                        }}
                        renderOption={(props, option) => {
                          const index = locations.findIndex((loc) => loc.value === option.value);
                          return (
                            <li
                              {...props}
                              key={option.value ?? option.label}
                              className='flex justify-between'
                              style={{
                                borderBottom: option.value === 0 ? '2px solid black' : 'none',
                                padding: '8px 16px',
                                cursor: 'pointer',
                              }}
                            >
                              <span>{option.label}</span>
                              <div className='flex flex-wrap items-center'>
                                {option.value === 0 ? null : option.template ? (
                                  <Icon style={{ color: '#50c760', fontWeight: 'bold' }}>check</Icon>
                                ) : (
                                  <>
                                    <DeleteForeverIcon
                                      style={{ color: 'red', marginRight: '8px', cursor: 'pointer' }}
                                      fontSize='small'
                                      onClick={(e) =>
                                        handleOpenDeleteLocationDialog(e, option, 'origin')
                                      }
                                    />
                                    <EditIcon
                                      style={{ color: 'blue', marginRight: '16px', cursor: 'pointer' }}
                                      fontSize='small'
                                      onClick={(e) => handleOpenEditLocationDialog(e, option)}
                                    />
                                  </>
                                )}
                                {index > 0 && option.template ? (
                                  <>
                                    <div>
                                      <Typography
                                        fontWeight={'bold'}
                                        fontSize={'6px'}
                                        sx={{ color: 'blue', marginRight: '2px' }}
                                      >
                                        {t('LOADZ_AI')}
                                      </Typography>
                                      <Typography
                                        fontWeight={'bold'}
                                        fontSize={'6px'}
                                        sx={{ color: 'blue', marginRight: '2px' }}
                                      >
                                        {t('ASSIST')}
                                      </Typography>
                                    </div>
                                    <AutoAwesomeIcon sx={{ color: 'blue' }} fontSize='6px' />
                                  </>
                                ) : null}
                              </div>
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <>
                            <InputLabel htmlFor='input-with-icon-adornment'>
                              {' '}
                              {bolJob == false
                                ? t('SELECT_QUARRY_PIT_MESSAGE')
                                : t('CREATE_AN_ORIGIN')}{' '}
                            </InputLabel>
                            <TextField
                              disabled={
                                jobtype == 'sub'
                                  ? true
                                  : !getValues('job_c_id').length
                                    ? true
                                    : false
                              }
                              {...params}
                              id={'locations'}
                              placeholder={bolJob ? t('WHAREHOUSE') : t('SELECT_OR_CREATE_AN_ORIGIN')}
                              className='mt-2 mb-0 mx-0 selectqp margin-x-0'
                              variant='outlined'
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                onKeyDown: (e) => {
                                  if (e.key === 'Enter') {
                                    // e.stopPropagation();
                                  }
                                },
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Tab') {
                                  handleKeyPress(e);
                                }
                                if (e.key === 'Enter') {
                                  handleKeyPress(e);
                                }
                              }}
                            />
                          </>
                        )}
                      />
                    )}
                  />
                </div>

                {!updateOrigin && (
                  <>
                    {locationStatus ? null : (
                      <>
                        {tooltipAlert &&
                          tooltipAlert !== null &&
                          tooltipAlert !== undefined &&
                          tooltipAlert == 'Quarry Pit' ? null : (
                          <div
                            className='mt-8 mb-16 mx-0 margin-x-0 location-btn'
                            style={{ alignSelf: 'center' }}
                          >
                            <InputAdornment position='start'>
                              <Tooltip
                                title={
                                  tooltipAlert && tooltipAlert !== undefined
                                    ? `${t('UPDATE')} ${tooltipAlert}`
                                    : t('UPDATE_ORIGIN')
                                }
                              >
                                <Fab
                                  disabled={
                                    jobtype == 'sub'
                                      ? true
                                      : !getValues('job_c_id').length
                                        ? true
                                        : false
                                  }
                                  color='primary'
                                  size='small'
                                  onClick={openOrigin}
                                  hidden={updateOriginhidden}
                                >
                                  <EditLocationAltIcon />
                                </Fab>
                              </Tooltip>
                            </InputAdornment>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
                {updateOrigin && (
                  <>
                    {tooltipAlert &&
                      tooltipAlert !== null &&
                      tooltipAlert !== undefined &&
                      tooltipAlert == 'Quarry Pit' ? null : (
                      <div
                        className='mt-8 mb-16 mx-0 margin-x-0 location-btn'
                        style={{ alignSelf: 'center' }}
                      >
                        <InputAdornment position='start'>
                          <Tooltip
                            title={
                              tooltipAlert && tooltipAlert !== undefined
                                ? `${t('UPDATE')} ${tooltipAlert}`
                                : t('UPDATE_ORIGIN')
                            }
                          >
                            <Fab
                              disabled={
                                jobtype == 'sub'
                                  ? true
                                  : !getValues('job_c_id').length
                                    ? true
                                    : false
                              }
                              color='primary'
                              size='small'
                              onClick={openOrigin}
                              hidden={updateOriginhidden}
                            >
                              <EditLocationAltIcon />
                            </Fab>
                          </Tooltip>
                        </InputAdornment>
                      </div>
                    )}
                  </>
                )}
              </div>

              <div className='w-1/2 flex justify-center destination-right mt-8 mb-16 px-5 pl-10'>
                <div className='flex flex-col margin-x-0 w-full'>
                  <Autocomplete
                    key={`destination-autocomplete-${destinationAutocompleteKey}`}
                    // disabled={
                    //   jobtype == 'sub'
                    //     ? true
                    //     : !locationQuarry || !getValues('quarry_pit').length
                    //     ? true
                    //     : false
                    // }
                    freeSolo={true}
                    value={destiAutoComplete}
                    options={locationsDestination}
                    // getOptionLabel={(option) => (option.label ? option.label : '')}
                    onInput={(e) => {
                      setOnInputText(e.target.value);

                      if (e.target.value != onChangeText) {
                        setIdlocations(null);
                        setLocationDestination(null);
                      }
                    }}
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue == 'object') {
                        newValue && newValue.label
                          ? setOnChangeText(newValue.label)
                          : setOnChangeText('');
                      }
                      if (newValue == null) {
                        setOnChangeText('');
                      }
                      if (newValue && typeof newValue == 'string') {
                        setOnChangeText(newValue);
                      }

                      setIdlocations(null);
                      setLocationDestination(null);
                      if (newValue) {
                        if (newValue.value == 0) {
                          setIsOpenLocationDes(true);
                          setValue('l_name', null);
                        }
                        if (newValue.value != 0) {
                          locationsDesi.forEach((loc) => {
                            if (loc && loc.l_id === newValue.value) {
                              setLocationDestination({
                                name: loc.l_name,
                                lat: loc.l_latitude,
                                lng: loc.l_longitude,
                                l_address: loc.l_address,
                                l_city: loc.l_city,
                                l_state: loc.l_state,
                                l_type: loc.l_type,
                                l_zip: loc.l_zip,
                                l_id: loc.l_id,
                                company_id: loc.company_id,
                              });
                              setIdlocations(loc.l_id);
                            }
                          });
                          setValue('l_name', newValue.label);
                        }
                      } else {
                        setValue('l_name', null);
                      }
                    }}
                    fullWidth
                    getOptionLabel={(option) =>
                      typeof option === 'string' ? option : option?.label || ''
                    }
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        key={option.value ?? option.label}
                        className='flex justify-between'
                        style={{
                          padding: '8px 16px',
                          cursor: 'pointer',
                        }}
                      >
                        <span>{option.label}</span>
                        {option.value === 0 ? null : (
                          <div className='flex flex-wrap items-center'>
                            <DeleteForeverIcon
                              style={{ color: 'red', marginRight: '8px', cursor: 'pointer' }}
                              fontSize='small'
                              onClick={(e) =>
                                handleOpenDeleteLocationDialog(e, option, 'destination')
                              }
                            />
                            <EditIcon
                              style={{ color: 'blue', marginRight: '16px', cursor: 'pointer' }}
                              fontSize='small'
                              onClick={(e) => handleOpenEditDestinationDialog(e, option)}
                            />
                          </div>
                        )}
                      </li>
                    )}
                    renderInput={(params) => (
                      <>
                        <InputLabel htmlFor='input-with-icon-adornment'>{t('DESTINATION')}</InputLabel>
                        <TextField
                          disabled={jobtype == 'sub' ? true : false}
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            onKeyDown: (e) => {
                              if (e.key === 'Enter') {
                                // e.stopPropagation();
                              }
                            },
                          }}
                          id={'locationsDestination'}
                          placeholder={t('DESTINATION')}
                          className='mt-2 mb-0 mx-0 selectqp margin-x-0'
                          variant='outlined'
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Tab') {
                              handleKeyPressDestination(e);
                            }
                            if (e.key === 'Enter') {
                              handleKeyPressDestination(e);
                            }
                          }}
                        />
                      </>
                    )}
                  />
                </div>

                {locationDestination ? (
                  <div
                    className='mt-8 mb-16 mx-0 margin-x-0 location-btn flex flex-row justify-end w-full pr-10'
                    style={{ alignSelf: 'center' }}
                  >
                    <InputAdornment position='start'>
                      <Tooltip title={t('UPDATE_DESTINATION')}>
                        <Fab
                          disabled={jobtype == 'sub' ? true : false}
                          color='primary'
                          size='small'
                          onClick={() => {
                            const resolvedCompanyId =
                              locationDestination?.company_id ||
                              prop_data?.id ||
                              store.getState().loadz_auth?.AuthReducer?.user?.user_id;
                            if (locationDestination) {
                              setLocationDestination({
                                ...locationDestination,
                                company_id: resolvedCompanyId,
                              });
                            }
                            setIsOpenLocationDes(true);
                          }}
                        >
                          <EditLocationAltIcon />
                        </Fab>
                      </Tooltip>
                    </InputAdornment>
                  </div>
                ) : null}
              </div>
            </div>
          )}

          <div className='flex mx-0 margin-x-0 flex-wrap'>
            {/* fulfillment warning */}
            {bolJob == false ? (
              <div className='w-1/2 flex flex-col mx-0 margin-x-0 px-5 pr-10 fullwidth'>
                <Controller
                  name='j_fullfillment_warning'
                  control={control}
                  render={({ field }) => (
                    <>
                      <InputLabel htmlFor='input-with-icon-adornment'>
                        {' '}
                        {t('FULFILLMENT_WARNING')}{' '}
                      </InputLabel>
                      <Tooltip
                        title={t('FULFILLMENT_WARNING_MESSAGE')} /* TODO Review before Live. Improved Message */
                        placement='right-start'
                      >
                        <TextField
                          {...field}
                          disabled={jobtype == 'sub' ? true : false}
                          className='mt-2 mb-0 mx-0 margin-x-0'
                          // label="FulFillment Warning"
                          placeholder={t('FULFILLMENT_WARNING')}
                          type={'number'}
                          id='j_fullfillment_warning'
                          onInput={(e) => {
                            if (e.target.value <= 0) {
                              const new_fields = inputFields.map((item) => ({
                                ...item,
                                full_warning: false,
                              }));
                              setInputFields(new_fields);
                              setValue('notification', new_fields);
                            }
                          }}
                          variant='outlined'
                          fullWidth
                        />
                      </Tooltip>
                    </>
                  )}
                />
              </div>
            ) : null}
            {/**FulFillment Total  */}
            {bolJob == false ? (
              <div className='w-1/2 flex flex-col mx-0 margin-x-0 px-5 pl-10 fullwidth'>
                <Controller
                  name='j_fullfillment_total'
                  control={control}
                  render={({ field }) => (
                    <>
                      <InputLabel htmlFor='input-with-icon-adornment'>
                        {' '}
                        {t('FULFILLMENT_TOTAL')}{' '}
                      </InputLabel>
                      <Tooltip
                        title={t('FULFILLMENT_TOTAL_ALERT_MESSAGE')} /* TODO Review before Live. Improved Message */
                        placement='right-start'
                      >
                        <TextField
                          {...field}
                          disabled={jobtype == 'sub' ? true : false}
                          className='mt-2 mb-0 mx-0 margin-x-0'
                          // label="FulFillment Total"
                          id='j_fullfillment_total'
                          onInput={(e) => {
                            setJTotal(e.target.value);
                            if (e.target.value <= 0) {
                              const new_fields = inputFields.map((item) => ({
                                ...item,
                                fulf_total: false,
                              }));
                              setInputFields(new_fields);
                              setValue('notification', new_fields);
                            }
                          }}
                          placeholder={t('FULFILLMENT_TOTAL')}
                          variant='outlined'
                          fullWidth
                          type={'number'}
                        />
                      </Tooltip>
                    </>
                  )}
                />
              </div>
            ) : null}
          </div>

          <div className='flex mx-0 margin-x-0 flex-wrap pt-10'>
            {/**notes */}
            {bolJob == false ? (
              <>
                <div className='w-full md:w-1/2 flex-col mx-0 margin-x-0 px-8 fullwidth'>
                  <Controller
                    name='j_notes'
                    control={control}
                    render={({ field }) => (
                      <>
                        <InputLabel htmlFor='input-with-icon-adornment'> {t('NOTES')} </InputLabel>
                        <TextField
                          {...field}
                          disabled={jobtype == 'sub' ? true : false}
                          className='mt-2 mb-16 mx-0 margin-x-0'
                          id='j_notes'
                          // label='Notes'
                          placeholder={t('NOTES')}
                          error={!!errors.j_notes}
                          helperText={errors?.j_notes?.message}
                          multiline
                          fullWidth
                        />
                      </>
                    )}
                  />
                </div>

                <div className='w-1/2 flex flex-col mx-0 margin-x-0 px-5 pl-10 fullwidth'>
                  <Controller
                    name='j_notes_drivers'
                    control={control}
                    render={({ field }) => (
                      <>
                        <InputLabel htmlFor='input-with-icon-adornment'>
                          {' '}
                          {t('NOTES_FOR_DRIVER')}{' '}
                        </InputLabel>
                        <TextField
                          {...field}
                          disabled={jobtype == 'sub' ? true : false}
                          className='mt-2 mb-16 mx-0 margin-x-0'
                          id='j_notes_drivers'
                          // label='Notes'
                          placeholder={t('NOTES_FOR_DRIVER')}
                          error={!!errors.j_notes_drivers}
                          helperText={errors?.j_notes_drivers?.message}
                          multiline
                          fullWidth
                        />
                      </>
                    )}
                  />
                </div>
              </>
            ) : null}
          </div>

          {/**order pick up number */}
          <div className='flex mx-0 margin-x-0 flex-wrap'>
            {bolJob && bolImage ? null : (
              <>
                <div className={`w-full md:w-1/2 flex-col mx-0 margin-x-0 px-8`}>
                  <Controller
                    name='order_pickup_id'
                    control={control}
                    render={({ field }) => (
                      <>
                        <InputLabel htmlFor='input-with-icon-adornment'>
                          {' '}
                          {t('ORDER_PICKUP_NUMBER')}{' '}
                        </InputLabel>
                        <TextField
                          {...field}
                          className='mt-2 mb-16 mx-0 margin-x-0'
                          id='order_pickup_id'
                          placeholder={t('ORDER_PICKUP_NUMBER')}
                          fullWidth
                        />
                      </>
                    )}
                  />
                </div>
                {bolJob == true ? (
                  <div className='w-1/2 flex flex-col mx-0 margin-x-0 px-5 pl-10 fullwidth'>
                    <Controller
                      name='j_notes_drivers'
                      control={control}
                      render={({ field }) => (
                        <>
                          <InputLabel htmlFor='input-with-icon-adornment'>
                            {' '}
                            {t('NOTES_FOR_DRIVER')}{' '}
                          </InputLabel>
                          <TextField
                            {...field}
                            disabled={jobtype == 'sub' ? true : false}
                            className='mt-2 mb-16 mx-0 margin-x-0'
                            id='j_notes_drivers'
                            // label='Notes'
                            placeholder={t('NOTES_FOR_DRIVER')}
                            error={!!errors.j_notes_drivers}
                            helperText={errors?.j_notes_drivers?.message}
                            multiline
                            fullWidth
                          />
                        </>
                      )}
                    />
                  </div>
                ) : null}
              </>
            )}
          </div>

          {/**check boxes for options */}
          <div className='flex mx-6 checkbox-text'>
            {/**scale ticket no required */}
            {bolJob == false ? (
              <Tooltip
                title={t('SCALE_TICKET_SCALE_NO_MANDATORY_MESSAGE')} //TODO improved Message. Review before LIVE.
                placement='top'
              >
                <FormControlLabel
                  // label="Scale"
                  // label="Enable tickets on this job to require the Scale Ticket on the Loadz E-Ticketing mobile app."
                  label={t('SCALE_TICKET_NUMBER_REQUIRED')}
                  control={
                    //
                    <Checkbox
                      disabled={jobtype == 'sub' ? true : false}
                      checked={scale}
                      onChange={handle}
                    />
                  }
                />
              </Tooltip>
            ) : null}
            {/* scale image required */}
            <Tooltip
              title={t('SCALE_TICKET_SCALE_IMAGE_MANDATORY_MESSAGE')} //TODO improved Message. Review before LIVE.
              placement='top'
            >
              <FormControlLabel
                label={
                  bolJob == false ? t('SCALE_TICKET_UPLOAD_REQUIRED') : t('SCAN_DOCUMENT_REQUIRED')
                }
                control={
                  //
                  <Checkbox
                    // disabled={jobtype == 'sub' ? true : false}
                    checked={scaleImageRequired}
                    onChange={handleScaleImageRequired}
                  />
                }
              />
            </Tooltip>
            {/* {scale && (
              <Tooltip
                title="Require scale ticket upload?" //TODO improved Message. Review before LIVE.
                placement="top"
              >
                <FormControlLabel
                  // label="Scale"
                  // label="Enable tickets on this job to require the Scale Ticket on the Loadz E-Ticketing mobile app."
                  label="Require scale ticket upload?"
                  control={
                    <Checkbox
                      //disabled={jobtype == 'sub' ? true : false}
                      checked={showTicketPicture}
                      onChange={handleTicketPicture}
                    />
                  }
                />
              </Tooltip>
            )} */}

            <Tooltip
              title={t('IF_ENABLED_TICKETS_WILL_DISPLAY_THE_JOBS_CUSTOMER_NAME')} //TODO improved Message. Review before LIVE.
              placement='top'
            >
              <FormControlLabel
                // label="Scale"
                // label="Enable tickets on this job to require the Scale Ticket on the Loadz E-Ticketing mobile app."
                label={t('DISPLAY_CUSTOMER_NAME_ON_DRIVER_TICKETS')}
                control={
                  <Checkbox
                    //disabled={jobtype == 'sub' ? true : false}
                    checked={showCustName}
                    onChange={handleShow}
                  />
                }
              />
            </Tooltip>

            {/* <Tooltip
              title="Disable Ticket Batching & Invoicing" //TODO improved Message. Review before LIVE.
              placement="top"
            >
              <FormControlLabel
                // label="Scale"
                // label="Enable tickets on this job to require the Scale Ticket on the Loadz E-Ticketing mobile app."
                label="Disable Ticket Batching & Invoicing"
                control={
                  <Checkbox
                    //disabled={jobtype == 'sub' ? true : false}
                    checked={disableTicketBatching}
                    onChange={handleDisableTicket}
                  />
                }
              />
            </Tooltip> */}
          </div>
        </div>
        <div className='w-1/2 newjob-map' style={{ paddingLeft: 20, position: 'relative' }}>
          <Maps
            destination={locationDestination}
            setWaypoint={setWaypoint}
            quarry={locationQuarry}
            setLoadMap={setLoadMap}
          />
          {(!locationDestination || !locationQuarry) && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                fontSize: '20px',
              }}
            >
              {t('PLEASE_SET_ADDRESS_COORDINATE_DATA_MESSAGE')}
            </div>
          )}
        </div>
      </div>
      <Divider></Divider>
      {/* <div className='flex mx-6 notification-h margin-x-0 mt-32'>
        <Typography variant="h6" gutterBottom component="div" className='font-bold'>
          Notifications
        </Typography>
      </div> */}

      <div className='notification-content'>
        <Controller
          name='notification'
          control={control}
          render={({ field }) => (
            <>
              {inputFields.map((inputField) => (
                <div key={inputField.id}>
                  <div className='flex mx-0 notification-content-inner margin-x-0 mt-32 items-center flex-wrap'>
                    <div className='flex mx-0 notification-h margin-x-0 mr-16'>
                      <Typography
                        variant='h6'
                        gutterBottom
                        component='div'
                        className='font-bold m-0'
                      >
                        {t('NOTIFICATIONS')}
                      </Typography>
                    </div>
                    {/* Language Selector */}
                    <div className='flex items-center ml-8'>
                      <Button
                        style={{ color: 'black', minWidth: 80 }}
                        onClick={(event) => handleLanguageMenuOpen(inputField.id, event)}
                      >
                        <img
                          className='mx-2 min-w-20'
                          src={`assets/images/flags/${notificationLanguages.find(l => l.id === (inputField.notification_language || 'en'))?.flag || 'us'}.png`}
                          alt={notificationLanguages.find(l => l.id === (inputField.notification_language || 'en'))?.title || 'English'}
                          style={{ width: 24, height: 16 }}
                        />
                        <Typography style={{ color: 'black', marginLeft: 4 }} className='font-Regular uppercase' color='textSecondary'>
                          {notificationLanguages.find(l => l.id === (inputField.notification_language || 'en'))?.title || 'English'}
                        </Typography>
                      </Button>
                      <Popover
                        open={Boolean(languageMenus[inputField.id])}
                        anchorEl={languageMenus[inputField.id]}
                        onClose={() => handleLanguageMenuClose(inputField.id)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                        classes={{ paper: 'py-8' }}
                      >
                        {notificationLanguages.map((lng) => (
                          <MenuItem
                            key={lng.id}
                            onClick={() => handleNotificationLanguageChange(inputField, lng)}
                          >
                            <img
                              className='min-w-20'
                              src={`assets/images/flags/${lng.flag}.png`}
                              alt={lng.title}
                              style={{ width: 24, height: 16, marginRight: 8 }}
                            />
                            {lng.title}
                          </MenuItem>
                        ))}
                      </Popover>
                    </div>
                    {getValues('j_fullfillment_warning') > 0 ? (
                      <Tooltip title={t('ENABLE_TO_SEND_ALERT_FULFILLMENT_WARNING_IS_TRIGGERED')}>
                        <FormControlLabel
                          name='full_warning'
                          label={t('FULFILLMENT_WARNING')} //link to read page
                          value={inputField.full_warning}
                          control={
                            <Checkbox
                              disabled={jobtype == 'sub' ? true : false}
                              checked={inputField.full_warning}
                              onChange={(event) => handleChangeInputwarning(inputField.id, event)}
                            />
                          }
                        />
                      </Tooltip>
                    ) : null}

                    {bolJob == true ? (
                      <Tooltip title={t('ENABLE_TO_SEND_ALERT_WHEN_TICKET_IS_DELIVERED')}>
                        <FormControlLabel
                          name='warn_delivered'
                          label={t('NOTIFY_WHEN_DELIVERED')} //link to read page
                          value={inputField.warn_delivered}
                          control={
                            <Checkbox
                              disabled={jobtype == 'sub' ? true : false}
                              checked={inputField.warn_delivered}
                              onChange={(event) =>
                                handleChangeInputWarnDelivered(inputField.id, event)
                              }
                            />
                          }
                        />
                      </Tooltip>
                    ) : null}

                    {bolJob == true ? (
                      <Tooltip title={t('ENABLE_TO_SEND_ALERT_WHEN_TICKET_IS_LOADED')}>
                        <FormControlLabel
                          name='warn_loaded'
                          label={t('NOTIFY_WHEN_LOADED')} //link to read page
                          value={inputField.warn_loaded}
                          control={
                            <Checkbox
                              disabled={jobtype == 'sub' ? true : false}
                              checked={inputField.warn_loaded}
                              onChange={(event) =>
                                handleChangeInputWarnLoaded(inputField.id, event)
                              }
                            />
                          }
                        />
                      </Tooltip>
                    ) : null}

                    {jTotal > 0 ? (
                      <Tooltip title={t('ENABLE_TO_SEND_WHEN_FULFILLMENT_TOTAL_IS_TRIGGERED')}>
                        <FormControlLabel
                          name='fulf_total'
                          label={t('FULFILLMENT_TOTAL')} //link to read page
                          value={inputField.fulf_total}
                          control={
                            <Checkbox
                              disabled={jobtype == 'sub' ? true : false}
                              checked={inputField.fulf_total}
                              onChange={(event) =>
                                handleChangeInputfulf_total(inputField.id, event)
                              }
                            />
                          }
                        />
                      </Tooltip>
                    ) : null}

                    {bolJob == false ? (
                      <Tooltip title={t('ENABLE_TO_SEND_ALERT_WHEN_THE_FIRST_TICKET_IS_COMPLETED_ON_THIS_JOB')}>
                        <FormControlLabel
                          name='first_load'
                          label={t('FIRST_LOAD_OF_THE_DAY')} //link to read page
                          value={inputField.first_load}
                          control={
                            <Checkbox
                              disabled={jobtype == 'sub' ? true : false}
                              checked={inputField.first_load}
                              onChange={(event) =>
                                handleChangeInputfirst_load(inputField.id, event)
                              }
                            />
                          }
                        />
                      </Tooltip>
                    ) : null}

                    <Tooltip title={t('ENABLE_TO_SEND_ALERT_WHEN_A_TICKET_IS_SET_TO_DELAYED_STATUS')}>
                      <FormControlLabel
                        name='delays'
                        label={t('DELAYS')} //link to read page
                        value={inputField.delays}
                        control={
                          <Checkbox
                            disabled={jobtype == 'sub' ? true : false}
                            checked={inputField.delays}
                            onChange={(event) => handleChangeInputdelays(inputField.id, event)}
                          />
                        }
                      />
                    </Tooltip>
                  </div>

                  <div className='flex mx-0 notification-content-inner notification-feilds bottom margin-x-0 mt-24 flex-wrap'>
                    <div className='flex flex-col mx-0 pr-10 notification-inner'>
                      <InputLabel htmlFor='input-with-icon-adornment'> {t('NAME')} </InputLabel>
                      <TextField
                        {...field}
                        disabled={jobtype == 'sub' ? true : false}
                        className='mt-2 mb-16 mx-0 margin-x-0'
                        // label="Name"
                        placeholder={t('NAME')}
                        type={'text'}
                        name='name'
                        variant='outlined'
                        value={inputField.name}
                        onChange={(event) => handleChangeInput(inputField.id, event)}
                        fullWidth
                        InputProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                    <div className='flex flex-col mx-0 pr-10 notification-inner'>
                      <InputLabel htmlFor='input-with-icon-adornment'>
                        {' '}
                        {t('EMAIL_NOT_REQUIRED')}{' '}
                      </InputLabel>
                      <TextField
                        {...field}
                        disabled={jobtype == 'sub' ? true : false}
                        className='mt-2 mb-16 mx-0 email margin-x-0'
                        // label="Email"
                        placeholder={t('EMAIL')}
                        name='email'
                        variant='outlined'
                        value={inputField.email}
                        onChange={(event) => handleChangeInput(inputField.id, event)}
                        InputProps={{
                          startAdornment: <InputAdornment position='start'></InputAdornment>,
                          shrink: true,
                        }}
                        fullWidth
                      />
                    </div>
                    <div className='flex flex-col mx-0 pr-10 notification-inner'>
                      <InputLabel htmlFor='input-with-icon-adornment'> {t('PHONE')} </InputLabel>
                      {/* <TextField
                        {...field}
                        disabled={jobtype == 'sub' ? true : false}
                        className="mt-2 mb-16 mx-0 phone margin-x-0"
                        // label="Phone"
                        placeholder="Phone"
                        name="phone"
                        type={'number'}
                        variant="outlined"
                        value={inputField.phone}
                        onChange={(event) => handleChangeInput(inputField.id, event)}
                        InputProps={{
                          startAdornment: <InputAdornment position="start"></InputAdornment>,
                          shrink: true,
                        }}
                        fullWidth
                      /> */}
                      <PhoneInput
                        {...field}
                        disabled={jobtype === 'sub' ? true : false}
                        country={'us'}
                        onlyCountries={['us', 'mx', 'co']}
                        value={`${inputField.country_code || '+1'}${inputField.phone || ''}`}
                        onChange={(value, data, event) => {
                          const fullNumber = value.replace(/\D/g, '');
                          const dialCode = data.dialCode;

                          const phoneNumber = fullNumber.substring(dialCode.length);

                          const phoneEvent = {
                            target: {
                              name: 'phone',
                              value: phoneNumber,
                            },
                          };

                          const countryCodeEvent = {
                            target: {
                              name: 'country_code',
                              value: `+${dialCode}`,
                            },
                          };

                          handleChangeInput(inputField.id, phoneEvent);
                          handleChangeInput(inputField.id, countryCodeEvent);
                        }}
                        inputProps={{
                          name: 'phone',
                          required: true,
                          className: 'mt-2 mb-16 mx-0 phone margin-x-0',
                        }}
                        containerStyle={{
                          height: '48px',
                          marginTop: '8px',
                          marginBottom: '64px',
                        }}
                        inputStyle={{
                          height: '48px',
                          width: '100%',
                          paddingLeft: '48px',
                        }}
                        countryCodeEditable={false}
                        enableSearch={false}
                      />
                    </div>
                    <div className='add-remobe-btn'>
                      <div
                        className='mt-0 mb-16 mx-2 addbtn margin-x-0'
                        style={{ alignSelf: 'center' }}
                      >
                        <InputLabel htmlFor='input-with-icon-adornment' className='invisible'>
                          {t('ADD')}
                        </InputLabel>
                        <InputAdornment position='start'>
                          <Tooltip title={t('ADD_NOTIFICATION')}>
                            <Fab
                              disabled={jobtype == 'sub' ? true : false}
                              color='primary'
                              size='small'
                              onClick={handleAddFields}
                            >
                              <AddIcon />
                            </Fab>
                          </Tooltip>
                        </InputAdornment>
                      </div>

                      <div
                        className='mt-0 mb-16 mx-2 remove-btn margin-x-0'
                        style={{ alignSelf: 'center' }}
                      >
                        <InputLabel htmlFor='input-with-icon-adornment' className='invisible'>
                          {t('REM')}
                        </InputLabel>
                        <InputAdornment position='start'>
                          <Tooltip title={t('REMOVE_NOTIFICATION')}>
                            <Fab
                              color='danger'
                              size='small'
                              disabled={inputFields.length === 1 || jobtype == 'sub' ? true : false}
                              onClick={() => handleRemoveFields(inputField.id)}
                            >
                              <RemoveIcon />
                            </Fab>
                          </Tooltip>
                        </InputAdornment>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.loadz_auth?.AuthReducer?.user,
  };
};
export default connect(mapStateToProps)(memo(CreateJob));
